var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standard-map',{attrs:{"value":_vm.mapCenter,"zoom":_vm.mapZoom,"height":_vm.mapHeight,"tile-url":_vm.tileUrl},on:{"initialized":_vm.onMapLoad},model:{value:(_vm.map),callback:function ($$v) {_vm.map=$$v},expression:"map"}})}
var staticRenderFns = []

export { render, staticRenderFns }